import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import {
  IconPhoneExample,
  IconEmailExample,
  IconInstagramExample,
  IconBackExample,
} from '../../components/UISystem/Icons';

/**
 * Icons Screen - UI System subpage
 *
 * Displays the icon system documentation using reusable icon components
 */
const IconsScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        {/* Back button */}
        <IconBack onClick={onBack} />

        {/* Title */}
        <h1 style={UI_SCREEN_STYLES.title}>Icons</h1>
      </div>

      {/* Horizontal line */}
      <div style={UI_SCREEN_STYLES.divider} />

      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        <IconPhoneExample />
        <IconEmailExample />
        <IconInstagramExample />
        <IconBackExample />
      </div>
    </div>
  );
};

export default IconsScreen;
